"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _text = require("../text");

var StatusIndicatorText = _text.Text.withComponent('span', {
  target: "e1oe48lr0"
});

StatusIndicatorText.defaultProps = (0, _objectSpread2.default)({}, _text.Text.defaultProps, {
  fontWeight: 'regular'
});
StatusIndicatorText.displayName = 'StatusIndicatorText';
var _default = StatusIndicatorText;
exports.default = _default;